"use strict";

function matchingEvidence(monitor, platformOrderNo) {
  return monitor && monitor.scope === 'PLATFORM_GROUP' && platformOrderNo && monitor.platformOrderNo === platformOrderNo ? monitor : null;
}
function wechatOrderText(wechat) {
  if (!wechat || !wechat.observedAt || wechat.observationSource === 'NONE') return '未知';
  if (wechat.freshnessState === 'STALE') return '证据已过期';
  if (!['CURRENT', 'VERIFIED_TERMINAL'].includes(wechat.freshnessState)) return '未知';
  if (wechat.orderState == null) return '未知';
  return {
    1: '待发货',
    2: '已发货待微信确认',
    3: '微信已确认收货',
    4: '交易完成'
  }[wechat.orderState] || '微信状态待核实';
}
function receiptText(wechat) {
  if (!wechat || !wechat.observedAt || wechat.observationSource === 'NONE') return '未知';
  if (wechat.freshnessState === 'STALE') return '证据已过期';
  if (!['CURRENT', 'VERIFIED_TERMINAL'].includes(wechat.freshnessState)) return '未知';
  return {
    WAIT_USER_OR_AUTO: '等待用户或自动确认',
    CONFIRMED_USER: '用户已确认',
    CONFIRMED_AUTO: '微信自动确认',
    CONFIRMED_METHOD_UNKNOWN: '已确认，方式未知'
  }[wechat.receiptState] || '未知';
}
function confirmMethodText(method) {
  return {
    1: '手动确认',
    2: '自动确认',
    AUTO: '自动确认',
    MANUAL: '手动确认',
    USER: '手动确认'
  }[String(method).toUpperCase()] || '未知';
}
function settlementText(wechat) {
  if (!wechat || !wechat.observedAt) return '未知';
  if (wechat.freshnessState === 'STALE') return '证据已过期';
  if (wechat.settlementState === 'VERIFIED_SIGNED_PUSH' && wechat.observationSource === 'WECHAT_SIGNED_SETTLEMENT_PUSH' && wechat.settlementTime && ['CURRENT', 'VERIFIED_TERMINAL'].includes(wechat.freshnessState)) return '已结算（微信验签推送）';
  return wechat.settlementState === 'UNVERIFIED' ? '未核实' : '未知';
}
function unitDivisionText(unit) {
  if (!unit || !unit.divisionState) return '未知';
  if (Array.isArray(unit.plans) && unit.plans.some(function (plan) {
    return plan.queryError;
  })) return '渠道状态待核验';
  if (unit.divisionState !== 'SUCCESS') {
    return ['NOT_READY', 'WAIT_CHANNEL', 'QUERYING', 'PROCESSING', 'UNKNOWN', 'MANUAL', 'CANCELLED'].includes(unit.divisionState) ? unit.divisionState : '未知';
  }
  // ponytail: a local unit flag needs matching completed plan evidence before displaying terminal success.
  var plans = unit.plans;
  return Array.isArray(plans) && plans.some(function (plan) {
    return plan.status === 'SUCCESS' && plan.statusUpdatedAt && ['CURRENT', 'VERIFIED_TERMINAL'].includes(plan.freshnessState);
  }) && plans.every(function (plan) {
    return ['SUCCESS', 'CANCELLED'].includes(plan.status) && ['CURRENT', 'VERIFIED_TERMINAL'].includes(plan.freshnessState);
  }) ? 'SUCCESS' : '未知';
}
function planText(plan) {
  if (plan && plan.queryError) return '渠道状态待核验';
  if (!plan || !plan.status || !plan.statusUpdatedAt) return '未知';
  if (plan.freshnessState === 'STALE') return "".concat(plan.status, "\uFF08\u5386\u53F2\u72B6\u6001\u5F85\u590D\u6838\uFF09");
  if (!['CURRENT', 'VERIFIED_TERMINAL'].includes(plan.freshnessState)) return '未知';
  return plan.status;
}
module.exports = {
  matchingEvidence: matchingEvidence,
  wechatOrderText: wechatOrderText,
  receiptText: receiptText,
  confirmMethodText: confirmMethodText,
  settlementText: settlementText,
  unitDivisionText: unitDivisionText,
  planText: planText
};